module.exports = __webpack_public_path__ + "static/media/charlene.47be0494.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/StartupDesigners/assets/charlene.jpg
// module id = 533
// module chunks = 0